export default {
  SELECT({commit}, payload) {
    commit('SELECT', payload)
  },
  RESET_STATE({commit}, payload) {
    commit('RESET_STATE', payload);
  },
  LAUNCH_RESEARCH({commit}, payload) {
    commit('LAUNCH_RESEARCH', payload)
  },
  LAUNCH_DETAIL_RESEARCH({commit}, payload) {
    commit('LAUNCH_DETAIL_RESEARCH', payload)
  },
  RESET_RESEARCH({commit}, payload) {
    commit('RESET_RESEARCH', payload);
  }
};